import React from "react";
import ComingSoon from "../components/ComingSoon";

const News = () => (
  <ComingSoon
    title="News & Events · Coming Soon"
    description="Heritage is in its founding year. Announcements, scholarship news, open houses and intake updates will be shared here as we go."
    testId="news-coming-soon"
  />
);

export default News;
